var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShoppingCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14072_7001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 15.0001C5.21928 15.0001 5.66699 14.5524 5.66699 14.0001C5.66699 13.4478 5.21928 13.0001 4.66699 13.0001C4.11471 13.0001 3.66699 13.4478 3.66699 14.0001C3.66699 14.5524 4.11471 15.0001 4.66699 15.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 15.0001C12.2193 15.0001 12.667 14.5524 12.667 14.0001C12.667 13.4478 12.2193 13.0001 11.667 13.0001C11.1147 13.0001 10.667 13.4478 10.667 14.0001C10.667 14.5524 11.1147 15.0001 11.667 15.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 3.5001H2.57699L2.16699 1.4001C2.14362 1.28546 2.08078 1.18265 1.98942 1.10957C1.89806 1.03648 1.78397 0.997743 1.66699 1.0001H-0.333008V2.0001H1.25699L3.16699 11.6001C3.19037 11.7147 3.2532 11.8176 3.34456 11.8906C3.43592 11.9637 3.55002 12.0025 3.66699 12.0001H12.667V11.0001H4.07699L3.66699 9.0001H12.667C12.7826 9.00293 12.8956 8.96561 12.9867 8.8945C13.0779 8.82339 13.1416 8.72289 13.167 8.6101L14.167 4.1101C14.1837 4.03591 14.1834 3.95888 14.1659 3.88487C14.1483 3.81085 14.1142 3.74181 14.066 3.68299C14.0178 3.62417 13.9568 3.57712 13.8876 3.54543C13.8185 3.51373 13.743 3.49823 13.667 3.5001ZM12.267 8.0001H3.47699L2.77699 4.5001H13.042L12.267 8.0001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14072_7001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShoppingCar);
export default __webpack_public_path__ + "static/media/ic-shopping-car.50a9d2375f311099c775bd56a30acc36.svg";
export { ForwardRef as ReactComponent };